<template>
  <div>
    <div v-if="breaker">
      <h4>Details for {{breaker.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{breaker[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="breaker.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "breaker",
  components: {
    BFR
  },
  props: {
    breaker: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["type", "Type"],
      ["modelNo", "Model Number"],
      ["ampRating", "Amp Rating"],
      ["voltageRating", "Voltage Rating"],
      ["interrupterRating", "Interrupter Rating (AIC)"],
      ["poleCount", "Poles"],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
